import {
  REPLENISH_PRODUCTS,
  REPLENISH_PRODUCTS_OFFSET,
  REPLENISH_PRODUCTS_COUNT,
  REPLENISH_PRODUCTS_SEARCH,
  REPLENISH_BUY_PRODUCT,
  CLEAR_REPLENISH_BUY_PRODUCT,
  REPLENISH_PRODUCTS_LOADING,
  REPLENISH_PRODUCTS_SUPPLIER_ID,
  REPLENISH_PRODUCTS_BRANDS,
  REPLENISH_PRODUCTS_LOADING_PRODUCTS,
} from '../constants/replenishProducts';

const initialState = {
  data: [],
  modalProduct: null,
  offset: 0,
  count: 0,
  perPage: 20,
  search: '',
  variants: [],
  supplierId: 0,
  brands: [],
  isLoading: false,
  isLoadingProducts: false,
};

const replenishProducts = (state = initialState, action) => {
  switch (action.type) {
    case REPLENISH_PRODUCTS:
      return {
        ...state,
        data: action.payload,
      };
    case REPLENISH_PRODUCTS_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case REPLENISH_BUY_PRODUCT:
      return {
        ...state,
        modalProduct: action.payload,
      };
    case REPLENISH_PRODUCTS_COUNT:
      return {
        ...state,
        count: +action.payload,
      };
    case REPLENISH_PRODUCTS_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case CLEAR_REPLENISH_BUY_PRODUCT:
      return {
        ...state,
        modalProduct: null,
      };
    case REPLENISH_PRODUCTS_SUPPLIER_ID:
      return {
        ...state,
        supplierId: action.payload,
      };
    case REPLENISH_PRODUCTS_BRANDS: {
      const data = action.payload.filter((item) => !!item.approved_for_replenishment);
      const supplierId = data.length ? data[0].supplier.id : 0;

      return {
        ...state,
        supplierId,
        brands: action.payload.map((item) => {
          const { supplier, replenish_billing_method } = item;
          const validated_credit_card =
            replenish_billing_method !== 'instant' ||
            (replenish_billing_method === 'instant' && item.stripe_data !== null);

          return {
            value: supplier.id,
            label: supplier.small_logo_path,
            approved_for_ecommerce: item.approved_for_ecommerce,
            approved_for_replenishment: item.approved_for_replenishment,
            replenishment_order_shipping_cost: item.replenishment_order_shipping_cost,
            minimum_products_for_replenishment_order: item.minimum_products_for_replenishment_order,
            name: supplier.name,
            validated_credit_card,
          };
        }),
      };
    }
    case REPLENISH_PRODUCTS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case REPLENISH_PRODUCTS_LOADING_PRODUCTS:
      return {
        ...state,
        isLoadingProducts: action.payload,
      };
    default:
      break;
  }

  return state;
};

export default replenishProducts;
